module.exports = __webpack_public_path__ + "static/media/minus.edb53bee.svg";